import {
  ContentfulImage,
  type ContentfulImageSchema
} from '@ecomm/contentful-components'
import classNames from 'classnames'

type ImageGalleryCurrentProps = {
  readonly current: ContentfulImageSchema
  readonly feature?: string
  readonly isModal?: boolean
}

export function ImageGalleryCurrent({
  current,
  feature,
  isModal = false
}: ImageGalleryCurrentProps) {
  return (
    <div
      className={classNames('col-span-12 flex relative', {
        'md:col-span-10 lg:col-span-10': !isModal
      })}
      data-component="ImageGalleryCurrent"
      data-testid="ImageGalleryCurrent"
    >
      {feature ? (
        <span className="absolute p-3 px-4 md:px-5 md:py-4 md:pt-3 min-w-28 text-white text-xs md:text-base font-bold leading-none rounded-xl bg-neutral-black bottom-3 right-3 md:bottom-8 md:right-8">
          {feature}
        </span>
      ) : null}
      <ContentfulImage
        className="w-full rounded-lg object-contain object-center lg:max-h-[450px]"
        {...current}
      />
    </div>
  )
}
